import { Divider, Text, TextFading } from '@yes.technology/react-toolkit'
import { Field, FieldsRow, ValueContainer } from './TaskObjectCard.styles'

type TaskFieldProps = {
  value: string
  label?: string
}

export type TaskFieldsRowProps = {
  firstField: TaskFieldProps
  secondField?: TaskFieldProps
  gridTemplate?: string
}

const TaskFieldsRow = ({
  firstField,
  secondField,
  gridTemplate = 'repeat(2, 1fr)'
}: TaskFieldsRowProps) => {
  return (
    <FieldsRow $gridTemplate={gridTemplate}>
      <Field>
        <TextFading>
          <Text variant='content-emphasis-02'>{firstField?.label}</Text>
        </TextFading>
        <Divider heightClass='small' color='gray' />
        <ValueContainer>
          <TextFading>{firstField?.value}</TextFading>
        </ValueContainer>
      </Field>
      {secondField && (
        <Field>
          <TextFading>
            <Text variant='content-emphasis-02'>{secondField?.label}</Text>
          </TextFading>
          <Divider heightClass='small' color='gray' />
          <ValueContainer>
            <TextFading>{secondField?.value}</TextFading>
          </ValueContainer>
        </Field>
      )}
    </FieldsRow>
  )
}

export default TaskFieldsRow
